import React from "react";
import HeroBanner from "../components/HeroBanner";

export default function Home() {
  return (
    <div>
    <HeroBanner />
  </div>
  );
}
